
import React from 'react';
import { GraduationCap } from 'lucide-react';
import KitTemplate from '@/components/hq/KitTemplate';

const TrainingKit = () => {
  const sections = {
    downloads: {
      title: "🔹 Downloads",
      description: "Training materials and certification resources",
      files: [
        { name: "New Hire Welcome Packet", type: "pdf" as const, size: "5.2 MB", placeholder: true },
        { name: "Alma LMS Guide", type: "pdf" as const, size: "2.1 MB", placeholder: true },
        { name: "Weekly Training Schedule", type: "docx" as const, size: "650 KB", placeholder: true }
      ]
    },
    sops: {
      title: "🔸 SOPs",
      description: "Training protocols and procedures",
      files: [
        { name: "Daily Workflow for Front Desk", type: "pdf" as const, placeholder: true },
        { name: "Patient Intake Protocol", type: "pdf" as const, placeholder: true },
        { name: "Studio Credit Explanation Script", type: "pdf" as const, placeholder: true },
        { name: "Facial and Injectable Prep Guidelines", type: "pdf" as const, placeholder: true }
      ]
    },
    training: {
      title: "🎓 Training",
      description: "Educational content and certification paths",
      files: [
        { name: "Intro to Alma AI Trainer", type: "mp4" as const, placeholder: true },
        { name: "Booking & Scheduling Walkthrough", type: "mp4" as const, placeholder: true },
        { name: "Delivering the Glow Quiz Experience", type: "mp4" as const, placeholder: true }
      ]
    }
  };

  return (
    <KitTemplate
      kitId="training"
      kitTitle="Training Kit"
      kitDescription="Staff onboarding, certification, and AI-powered learning with Alma"
      icon={<GraduationCap className="h-6 w-6 text-blue-400" />}
      sections={sections}
    />
  );
};

export default TrainingKit;
